export function Footer() {
  return (
    <footer className="app-footer">
      Cleveland Clinic <span className="app-footer-sep">·</span> Clinical Search{" "}
      <span className="app-footer-sep">·</span>{" "}
      <span className="app-footer-muted">Research use only</span>
    </footer>
  );
}
